import { render, staticRenderFns } from "./HeightAndAlignment.vue?vue&type=template&id=bba7e414&scoped=true"
import script from "./HeightAndAlignment.vue?vue&type=script&lang=js"
export * from "./HeightAndAlignment.vue?vue&type=script&lang=js"
import style0 from "./HeightAndAlignment.vue?vue&type=style&index=0&id=bba7e414&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba7e414",
  null
  
)

export default component.exports